import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-portal-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.scss'],
})
export class PortalFooterComponent implements OnInit {
  @Input() darkMode = 'light';
  constructor() {}
  year = new Date().getFullYear();
  ngOnInit(): void {}
}
